// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261104T161551403Z",
  "builtAt": "2026-11-04T16:15:51.403Z"
} as const;
